import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import getMe from "../../api/UsersApi";
// import getRole from "../../api/RolesApi";
import { UserRole, User } from "../../models/User";
import { useLocation, useNavigate } from "react-router-dom";
import getMe from "../../api/UsersApi";
import getRole from "../../api/RolesApi";
import { useAuth, normalizeRole } from "../../util/Auth";
import {
  mergePolicies,
  resolvePermissions,
  INTERVIEWER_CAPABILITY_NAMES,
  ASSISTANT_CAPABILITY_NAMES,
} from "../../util/permissions";
import { isContactInfoStale } from "../../util/contactInfoPolicy";

export default function Login() {
  const { t } = useTranslation();
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userResponse = await getMe();
        console.log("Login successful");
        console.log("User info:", JSON.stringify(userResponse));
        const myUser: User = {
          id: userResponse.id,
          first_name: userResponse.first_name,
          last_name: userResponse.last_name,
          role: userResponse.role,
          cod_curso: userResponse.cod_curso,
          cod_nivel: userResponse.cod_nivel,
          num_ordem: userResponse.num_ordem,
          email: (userResponse as any).email ?? undefined,
          phone: (userResponse as any).phone ?? undefined,
          preferred_email: (userResponse as any).preferred_email ?? undefined,
          contact_info_updated_date_utc: (userResponse as any).contact_info_updated_date_utc ?? undefined,
          roles: [],
          permissions: {
            "shift.assign_any_interviewer": false,
            "shift.assign_any_assistant": false,
            "shift.remove_any_interviewer": false,
            "shift.remove_any_assistant": false,
          }
        };
        setUser(myUser);

        const roleResponse = await getRole(userResponse.role);
        console.log("Role info:", JSON.stringify(roleResponse));

        // Merge role-level and user-level policies, then resolve to PermissionMap.
        const rolePolicies: { id?: string; name?: string }[] =
          (roleResponse as any).policies?.map((p: any) => p.policy) ?? [];
        const userPolicies: { id?: string; name?: string }[] =
          (userResponse as any).policies?.map((p: any) => p.policy) ?? [];
        const merged = mergePolicies(rolePolicies, userPolicies);
        myUser.permissions = resolvePermissions(merged);
        console.log("Resolved permissions:", JSON.stringify(myUser.permissions));

        // Build roles: start from the Directus role name, then augment with any
        // matching policies so that users assigned capability policies directly
        // (instead of via a recognized role) still get the correct role entry.
        const normalizedRole = normalizeRole(roleResponse.name);
        if (!normalizedRole) {
          console.error("Invalid role name:", roleResponse.name);
        }
        const roles: UserRole[] = normalizedRole ? [normalizedRole] : [];
        const policyNames = merged.map(p => (p.name ?? "").toLowerCase());
        if (!roles.includes("entrevistador") &&
            INTERVIEWER_CAPABILITY_NAMES.some(n => policyNames.includes(n))) {
          roles.push("entrevistador");
        }
        const assistantOnlyNames = ASSISTANT_CAPABILITY_NAMES.filter(
          n => !INTERVIEWER_CAPABILITY_NAMES.includes(n)
        );
        if (!roles.includes("entrevistador") && !roles.includes("assistente") &&
            assistantOnlyNames.some(n => policyNames.includes(n))) {
          roles.push("assistente");
        }
        myUser.roles = roles;
        setUser({ ...myUser });
        navigate(isContactInfoStale(myUser) ? "/update-contact-info" : "/user-home");

      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData();
  }, [location.search, navigate, setUser]);

  return (
    <div className="cidades-page">
      <h1>
        {t("pages.login.loading")} {user?.first_name} {user?.last_name} {user?.cod_curso}
      </h1>
      {/* <p>Me: {JSON.stringify(user)}</p> */}
    </div>
  );
}
